export default "__VITE_ASSET__DWln_nTE__"